import { render, staticRenderFns } from "./ImportInvoices.yaml?vue&type=template&id=0c31071c&component"
import script from "./ImportInvoices.yaml?vue&type=script&lang=ts&component"
export * from "./ImportInvoices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports